import { useQuery } from '@tanstack/react-query';
import { IGetDashboardJobsParams } from '../dashboardJobsApi';
import { dashboardJobsService } from '../dashboardJobsService';
import { IDashboardJob } from '../dashboardJobsTypes';

export function useGetDashboardJobs(params: IGetDashboardJobsParams) {
  const query = useQuery<IDashboardJob[]>({
    queryKey: ['dashboard-jobs', params],
    queryFn: () => dashboardJobsService.getDashboardJobs(params),
    staleTime: 60 * 1000, // 1 minute
    gcTime: 60 * 1000, // 1 minute
  });

  return {
    ...query,
    data: query.data ?? [],
  };
}
